import { gsap } from "gsap";

const lockScrolling = (isLocked) => {
    document.querySelector('body').style.overflow = isLocked ? 'hidden' : '';
};

export default {
    name: 'fetching',

    bind(el, binding) {
        if (!binding.value) return;

        lockScrolling(binding.modifiers.lock);

        // Animate height to 100vh
        gsap.to(el, { duration: 0.3, height: '100vh' });
    },

    update(el, binding) {
        if (binding.value) return;

        lockScrolling(false);

        // Animate height back to auto
        gsap.to(el, { duration: 0.3, height: 'auto' });
    },
};
